export function PrivacyModal({ onClose }) {
  return (
    <div className="lr-terms-overlay" data-testid="privacy-modal">
      <div className="lr-terms-modal">
        <button className="lr-terms-close" data-testid="privacy-modal-close" onClick={onClose}>&times;</button>
        <h3 className="lr-terms-title">Privacy Policy</h3>
        <div className="lr-terms-body" data-testid="privacy-modal-body">
          <p><strong>PRIVACY POLICY</strong><br/>(Last updated: March 23, 2026)</p>
          <p>Las Ruinas Bathhouse &amp; Gym LLC (&ldquo;Las Ruinas,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our booking system at lasruinas.online.</p>
          <h4>1. Information We Collect</h4>
          <p>When you make a booking we collect:</p>
          <ul>
            <li>Your name</li>
            <li>Your email address</li>
            <li>Payment information (processed securely by Stripe &mdash; we never store your card details)</li>
            <li>Number of guests</li>
            <li>Promo code (if used)</li>
            <li>Your agreement to our Terms &amp; Conditions</li>
          </ul>
          <p>For walk-in bookings created by staff, we may also collect your phone number.</p>
          <h4>2. How We Use Your Information</h4>
          <p>We use your information to:</p>
          <ul>
            <li>Process and confirm your booking</li>
            <li>Send you a booking confirmation email</li>
            <li>Send you a pre-visit reminder email</li>
            <li>Send you a post-visit follow-up email</li>
            <li>Provide customer support</li>
            <li>Improve our services</li>
          </ul>
          <p>We do not send marketing emails. We do not sell your data. We do not share your data with third parties except as described below.</p>
          <h4>3. Third-Party Services</h4>
          <p>We use the following trusted third-party services that may receive your information:</p>
          <p><strong>Stripe</strong> (stripe.com) &mdash; Payment processing. Your payment card details are collected directly and securely by Stripe and never touch our servers. Stripe is PCI DSS Level 1 certified.</p>
          <p><strong>Resend</strong> (resend.com) &mdash; Email delivery. Your name and email address are used to send you transactional emails related to your booking.</p>
          <h4>4. Cookies &amp; Tracking</h4>
          <p>Our booking system does not use tracking cookies or analytics pixels. Stripe.js (loaded for payment processing) and Google Fonts may set their own cookies as part of their standard operation.</p>
          <h4>5. Data Retention</h4>
          <p>We retain your booking information for a minimum of 3 years for legal and accounting purposes. You may request deletion of your personal data by contacting us directly, subject to our legal retention obligations.</p>
          <h4>6. Your Rights</h4>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data (subject to legal retention requirements)</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p>To exercise any of these rights, contact us at hello@lasruinas.com.</p>
          <h4>7. Children&rsquo;s Privacy</h4>
          <p>Our services are not directed to children under 18. We do not knowingly collect personal information from minors.</p>
          <h4>8. Security</h4>
          <p>We take reasonable technical and organizational measures to protect your personal information. Payment data is handled exclusively by Stripe, which maintains the highest level of PCI compliance.</p>
          <h4>9. Governing Law</h4>
          <p>This Privacy Policy is governed by the laws of the Commonwealth of Puerto Rico.</p>
          <h4>10. Contact</h4>
          <p>Las Ruinas Bathhouse &amp; Gym LLC<br/>104 C. de la Cruz, San Juan, 00901, Puerto Rico<br/>Email: hello@lasruinas.com<br/>Phone: +1 786-535-8054</p>
        </div>
        <button className="lr-terms-agree-btn" data-testid="privacy-modal-close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
